// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    }); 
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// Observe visibility once; fallback geometry work is limited to one animation frame.
(function () {
  var observer, videos = new Set(), visible = new Set(), frame = 0;
  function apply(video) {
    var play = visible.has(video) && !document.hidden;
    if (play && video.paused) { var pending = video.play(); if (pending && pending.catch) pending.catch(function () {}); }
    else if (!play && !video.paused) video.pause();
  }
  function measure() {
    frame = 0;
    videos.forEach(function (video) {
      var rect = video.getBoundingClientRect(), height = window.innerHeight;
      if (rect.height > 0 && rect.bottom > rect.height * .5 && rect.top < height - rect.height * .5) visible.add(video); else visible.delete(video);
      apply(video);
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
  function init() {
    if (typeof window.IntersectionObserver === 'function' && !observer) observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting && entry.intersectionRatio >= .5) visible.add(entry.target); else visible.delete(entry.target); apply(entry.target); });
    }, {threshold: [0, .5]});
    document.querySelectorAll('video[autoplay]').forEach(function (video) {
      if (video.closest('media-gallery') || videos.has(video)) return;
      videos.add(video); if (observer) observer.observe(video);
    });
    if (!observer && videos.size) schedule();
  }
  if (typeof window.IntersectionObserver !== 'function') { window.addEventListener('scroll', schedule, {passive: true}); window.addEventListener('resize', schedule, {passive: true}); }
  document.addEventListener('visibilitychange', function () { if (observer) videos.forEach(apply); else schedule(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();

document.addEventListener("DOMContentLoaded", () => {
  const pad = v => String(v).padStart(2, "0");

  let countdowns = [], countdownTimer = null;
  const countDown = () => {
    let running = false;
    countdowns.forEach(section => {
      if (!section.isConnected) return;
      const dateValue = section && section.dataset ? section.dataset.date : "";
      const target = dateValue ? new Date(dateValue).getTime() : NaN;
      const diff = target - Date.now();

      const els = {
        d: section.querySelector(".main_cdays .wb_cdays"),
        h: section.querySelector(".main_chours .wb_chours"),
        m: section.querySelector(".main_cminutes .wb_cminutes"),
        s: section.querySelector(".main_cseconds .wb_cseconds"),
        msg: section.querySelector(".main_ctext")
      };

      const setUnit = (key, value) => {
        if (els[key] && els[key].textContent !== value) els[key].textContent = value;
      };

      const hideUnit = key => {
        if (els[key] && els[key].parentElement) {
          els[key].parentElement.style.display = "none";
        }
      };

      const showUnit = key => {
        if (els[key] && els[key].parentElement) {
          els[key].parentElement.style.display = "";
        }
      };

      if (diff <= 0 || !Number.isFinite(target)) {
        if (els.msg && els.msg.textContent.trim()) {
          ["d","h","m","s"].forEach(hideUnit);
          section.classList.remove("bd-countdown-hidden");
          section.classList.add("bd-countdown-ready");
          section.style.display = "inline-block";
          els.msg.style.display = "block";
        } else {
          section.classList.remove("bd-countdown-ready");
          section.classList.add("bd-countdown-hidden");
          section.style.display = "none";
        }
      } else {
        running = true;
        section.classList.remove("bd-countdown-hidden");
        section.classList.add("bd-countdown-ready");
        section.style.display = "";
        ["d","h","m","s"].forEach(showUnit);
        setUnit("d", pad(Math.floor(diff / 86400000)));
        setUnit("h", pad(Math.floor(diff % 86400000 / 3600000)));
        setUnit("m", pad(Math.floor(diff % 3600000 / 60000)));
        setUnit("s", pad(Math.floor(diff % 60000 / 1000)));
        els.msg && (els.msg.style.display = "none");
      }
    });
    return running;
  };
  const initCountdown = () => {
    clearInterval(countdownTimer); countdownTimer = null;
    countdowns = Array.from(document.querySelectorAll('.countd_all'));
    if (!document.hidden && countDown()) countdownTimer = setInterval(() => { if (!countDown()) { clearInterval(countdownTimer); countdownTimer = null; } }, 1000);
  };
  document.addEventListener('shopify:section:load', initCountdown);
  document.addEventListener('visibilitychange', initCountdown);
  initCountdown();
});
